<template>
  <div v-show="this.$root.user != ''" class="profile-overlay-menu hide">
    <div class="content">
      <div class="user-data">
        <div class="photo" :style="photoStyle">

        </div>
        <div>
          <div class="name">
          {{ this.$root.user.name }}
          </div>
        </div>
      </div>
    </div>
    <a v-on:click="this.$root.logout" class="logout" href="javascript:void(0)"><i class="fa fa-power-off"></i>Kijelentkezés</a>
  </div>
</template>
<script>
export default {
  data: function() {
    return {}
  },
  computed: {
    userType: function() {
      return this.$root.user.employee == 0 ? 'Hallgató' : 'Egyéb';
    },
    userTypeClass: function() {
      return this.$root.user.employee == 0 ? 'student' : 'teacher';
    },
    photoStyle: function() {
      return {
        'background-image': "url('"+(this.$root.user.avatar_base64 != undefined ? this.$root.user.avatar_base64 : '')+"')"
      }
    }
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// tpl_profile_menu.vue?2e1fc9ca